import realEstateImage from '../components/Home/img/real-estate.png';
import transportImage from '../components/Home/img/transport.jpg';
import electronicsImage from '../components/Home/img/electronics.png';
import jobImage from '../components/Home/img/job.png';
import servicesImage from '../components/Home/img/services.png';
import homeImage from '../components/Home/img/home.png';
import gardenImage from '../components/Home/img/garden.png';
import childrenImage from '../components/Home/img/children.png';
import petsImage from '../components/Home/img/pets.png';
import fashionImage from '../components/Home/img/fashion.png';
import sportsImage from '../components/Home/img/sports.png';
import healthImage from '../components/Home/img/health.png';
import educationImage from '../components/Home/img/education.png';
import rentalImage from '../components/Home/img/rental.png';
import hobbiesImage from '../components/Home/img/hobbies.png';
import partsImage from '../components/Home/img/parts.png';
import accessoriesImage from '../components/Home/img/accessories.png';
import foodImage from '../components/Home/img/food.png';

// These values MUST match categoryFieldsConfig.js's keys exactly — that
// config is what CreateListing actually writes into a real listing's
// `category` field. A live production data check (SEO Phase 2 audit)
// found this map had drifted from that config for 10 of 18 categories
// (e.g. 'Робота' here vs the real stored 'Карʼєра', 'Мода' vs 'Стиль') —
// CategoryFeedPage.js/Feed.js's exact-match filter (`x.category ===
// categoryName`) meant `/category/:slug` silently showed ZERO real
// listings for every one of those 10 categories, which also made the
// P0 SEO fix (real title/canonical on this route) land on empty pages
// for most categories. Fixed to the real values so category pages and
// their SEO metadata now describe actual inventory.
export const slugToName = {
  'real-estate': 'Житло та нерухомість',
  'transport': 'Транспорт',
  'electronics': 'Гаджети',
  'job': 'Карʼєра',
  'services': 'Майстри та послуги',
  'home': 'Дім та затишок',
  'garden': "Для саду та подвір'я",
  'children': 'Малеча',
  'pets': 'Домашні улюбленці',
  'fashion': 'Стиль',
  'sports': 'Активність та спорт',
  'health': 'Б’юті',
  'education': 'Знання та Навчання',
  'rental': 'Оренда та прокат',
  'parts': 'Запчастини та аксесуари',
  'accessories': 'Аксесуари',
  'food': 'Продукти та їжа',
  'hobbies': 'Хобі',
};

export const nameToSlug = Object.fromEntries(
  Object.entries(slugToName).map(([slug, name]) => [name, slug])
);

export const categoryImages = {
  'Житло та нерухомість': realEstateImage,
  'Транспорт': transportImage,
  'Гаджети': electronicsImage,
  'Карʼєра': jobImage,
  'Майстри та послуги': servicesImage,
  'Дім та затишок': homeImage,
  "Для саду та подвір'я": gardenImage,
  'Малеча': childrenImage,
  'Домашні улюбленці': petsImage,
  'Стиль': fashionImage,
  'Активність та спорт': sportsImage,
  'Б’юті': healthImage,
  'Знання та Навчання': educationImage,
  'Оренда та прокат': rentalImage,
  'Запчастини та аксесуари': partsImage,
  'Аксесуари': accessoriesImage,
  'Продукти та їжа': foodImage,
  'Хобі': hobbiesImage,
};
